var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-full",attrs:{"type":"card-full"}},[(_vm.isPrint)?_c('i',{staticClass:"el-icon-printer icon",on:{"click":_vm.print}}):_vm._e(),_c('div',{staticClass:"con-box"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }